import React, {useEffect} from 'react'
import Privacy from "./Privacy.jsx"

const PrivacyContainer = () => {

    useEffect(() => {
    }, [])

    return (
        <Privacy/>
    )
}

export default PrivacyContainer